import { isDate } from 'lodash-es'
import { format, parseISO } from 'date-fns'
import DateFormats from '@corp/constants/DateFormats'
import { isString } from '@corp/helpers/string'
export { isToday } from 'date-fns'
export { isDate, parseISO }

// matches dates in the ISO 8601 format:
// 2018-09-27, 2018-09-27T18:43, 2018-09-27T18:43:30Z
const DATE_REGEX = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(T(2[0-3]|[01][0-9]):([0-5][0-9])(:([0-5][0-9]))?(\.[0-9]+)?Z?)?/

// Public: Checks if a string is a valid date.
export function isValidDate (value: string | Date): value is Date {
  return isDate(value) || DATE_REGEX.test(value)
}

export interface FormatOptions {
  format?: keyof typeof DateFormats
}

// Public: Formats an ISO8601 date string or a Date object in the specified format.
//
// date - Date object or ISO8601 date string
// format - The alias of the format to be applied
// human - Returns a human friendly string when possible, defaults to format
//
// Returns a String with the date formatted as specified.
export function formatDate (
  date: string | Date,
  { format: alias = 'date' }: FormatOptions = {},
) {
  if (!date) return ''
  if (isString(date)) date = alias === 'date' ? parseDate(date) : parseISO(date)
  return format(date, DateFormats[alias])
}

// Public: Parses an ISO8601 date string ignoring time and timezone information.
//
// Returns a Date.
export function parseDate (date: string | Date): Date {
  return isString(date) ? parseISO(date.split('T')[0]) : withoutTime(date)
}

// Public: Compares the date with the current day.
export function isPastDay (date: string | Date) {
  return withoutTime(date) < withoutTime(new Date())
}

function withoutTime (date: string | Date) {
  if (isString(date))
    date = parseDate(date)

  date.setHours(0, 0, 0, 0)

  return date
}
